import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/inventory`;

export const invApi = (token) => {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  return {
    get: (path, params) => axios.get(`${API}${path}`, { ...h, params }).then(r => r.data),
    post: (path, body) => axios.post(`${API}${path}`, body, h).then(r => r.data),
    patch: (path, body) => axios.patch(`${API}${path}`, body, h).then(r => r.data),
    upload: (path, file) => {
      const fd = new FormData();
      fd.append('file', file);
      return axios.post(`${API}${path}`, fd, { headers: { ...h.headers, 'Content-Type': 'multipart/form-data' }, timeout: 120000 }).then(r => r.data);
    },
  };
};

export const errMsg = (e, fallback = 'Erreur') => e?.response?.data?.detail || fallback;
export const money = (v) => `${Number(v || 0).toFixed(2)} $`;
export const qty = (v) => Number(v || 0).toLocaleString('fr-CA', { maximumFractionDigits: 2 });
export const invField = 'bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 focus:border-amber-500/50 focus:outline-none';
export const invInput = `w-full ${invField}`;

export const StockBadge = ({ item }) => {
  const s = Number(item.stock_qty || 0);
  const stocked = item.strategy === 'stocked';
  const low = stocked && s <= Number(item.min_qty || 0);
  const cls = low ? 'bg-red-500/15 text-red-300' : s < 0 ? 'bg-sky-500/15 text-sky-300' : s === 0 ? 'bg-slate-700 text-slate-300' : 'bg-emerald-500/15 text-emerald-300';
  const label = !stocked && s <= 0 ? (s < 0 ? `À commander ${qty(-s)}` : 'Sur commande') : `Stock ${qty(s)}`;
  return <span className={`text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${cls}`} data-testid={`stock-badge-${item.id}`}>{label}</span>;
};
